// extracted by mini-css-extract-plugin
export default {"mainContainer":"r2-r3_mainContainer__P3KxK","R2R3Container":"r2-r3_R2R3Container__-37m2"};